export const SET_FROZEN_ENTITY_ACTION = 'SET_FROZEN_ENTITY';

export type SetFrozenEntityIdAction = {
  type: typeof SET_FROZEN_ENTITY_ACTION;
  payload: string | null;
};

export const setFrozenEntityIdAction = (actionId: string | null): SetFrozenEntityIdAction => ({
  type: SET_FROZEN_ENTITY_ACTION,
  payload: actionId,
});
